import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import MobileBottomBar from './components/MobileBottomBar';
import QuoteModal from './components/QuoteModal';
import Analytics from './components/Analytics';

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <>
      <ScrollToTop />
      <Analytics />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="grow pb-24 md:pb-0">
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
        <MobileBottomBar onGetQuote={() => setQuoteOpen(true)} />
        <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
      </div>
    </>
  );
}

export default App;
